export default __webpack_public_path__ + "static/media/arrow-underline-right.f4802407.svg";